<template>
  <v-app>
    <div class="bg">

      <v-container fluid fill-height>
        <v-row>
          <v-col cols="12">
            <v-row
                align="center"
                justify="center"
                style="height:600px;"
            >
              <v-card
                  class="elevation-24"
                  color="white"
                  min-width="420px"
              >
                <div
                    class="pa-6"
                    :class="{ 'pa-12': $vuetify.breakpoint.lgAndUp }"
                >
                  <p id="logo" class="text-center">
                  </p>
                  <v-card-text>
                    <p class="pa-3 grey--text text-center">
                      Wilkommen beim AutoYast Template Builder
                    </p>
                    <v-form
                        id="loginform"
                        method="POST"
                        @keyup.enter.native="login"
                    >
                      <v-text-field
                          id="username"
                          v-model="input.username"
                          name="_username"
                          data-vv-name="username"
                          label="E-Mail"
                          type="text"
                          required="required"
                          autocomplete="username"
                          autofocus
                      />
                      <v-text-field
                          id="password"
                          v-model="input.password"
                          data-vv-name="password"
                          name="_password"
                          label="Kennwort"
                          type="password"
                          required="required"
                          autocomplete="password"
                      />
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="primary"
                        large
                        rounded
                        type="submit"
                        class="px-12"
                        @click.prevent="login()"
                    >
                      Anmelden
                    </v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-snackbar
          v-model="displayLoginErrorMessage"
          color="error"
          :top="true"
      >
        Login fehlgeschlagen
      </v-snackbar>
    </div>
  </v-app>
</template>

<script>

export default {
  name: 'LoginPage',
  props: {
    loginErrorMessage: String,
  },
  data() {
    return {
      displayLoginErrorMessage: false,
      input: {
        username: '',
        password: ''
      }
    };
  },
  methods: {
    displayLoginError(show) {
      this.displayLoginErrorMessage = show;
    },
    login() {
      this.displayLoginError(false);
      this.$store
          .dispatch('authStore/login', {
            username: this.input.username,
            password: this.input.password
          })
          .then(response => {
            if (response) {
              if (this.$route.query.redirect) {
                this.$router.push(
                    this.$route.query.redirect
                )
              } else {
                this.$router.push({name: 'Home'})
              }
            } else {
              Promise.reject(Error());
            }
          })
          .catch(() => {
            this.displayLoginError(true);
          })
    },
  },
};
</script>
<style lang="css" scoped>
.bg {
  background: url("/background.svg");
  background-size: cover;
  height: 100%;
}
</style>
